<template>
  <div
    class="mx-auto flex flex-wrap items-center px-24 py-8 transition-[margin] duration-200 md:flex-nowrap lg:max-w-[1184px] lg:px-32"
    :class="{ '-mt-44 md:mt-0': isSearchBarActive }"
  >
    <BurgerButton class="flex-1 md:hidden" />

    <TheLogo class="h-16 shrink-0 md:h-24" decoding="sync" loading="eager" />
    <div
      class="order-last mt-4 flex grow basis-full flex-row-reverse md:order-none md:ml-16 md:mr-4 md:mt-0 md:flex-row md:gap-x-16 lg:ml-32 lg:mr-8 lg:gap-x-32"
      :class="{ '-ml-24 ': isBuybackEnabled }"
    >
      <SearchBar class="z-[1] grow" />
      <div
        v-if="isBuybackEnabled"
        class="mr-16 grid shrink-0 transition-[grid-template-columns,margin] md:mr-0 md:transition-none"
        :class="
          isSearchBarActive
            ? 'grid-cols-[0fr] md:grid-cols-[1fr] duration-300'
            : 'grid-cols-[1fr] duration-150 ease-[cubic-bezier(0.5,0,0.2,1)]'
        "
      >
        <div class="flex justify-end gap-8 overflow-hidden">
          <TradeInButton class="relative ml-24 md:ml-0" />
        </div>
      </div>
    </div>
    <div class="flex flex-1 items-center justify-end gap-x-4 lg:gap-x-8">
      <RevLink
        class="hidden text-nowrap px-12 py-8 md:block"
        :to="`/${locale}/help`"
        :tracking="{ name: i18n(translations.help), zone: 'header' }"
        :underlined="false"
        >{{ i18n(translations.help) }}</RevLink
      >
      <BmProButton v-if="isBmProButtonEnabled" />
      <UserIcon />
      <CartIcon data-test="icon-cart" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevLink } from '@ds/components/Link'

import SearchBar from '~/scopes/search-bar/SearchBar.vue'
import { useToggleSearchBar } from '~/scopes/search-bar/composables/useToggleSearchBar'

import TheLogo from '../../TheLogo.vue'

import BmProButton from './BmProButton.vue'
import BurgerButton from './BurgerButton.vue'
import CartIcon from './CartIcon.vue'
import translations from './Main.translations'
import TradeInButton from './TradeInButton.vue'
import UserIcon from './UserIcon.vue'

const { isSearchBarActive } = useToggleSearchBar()
const { features, market } = useMarketplace()
const experiments = useExperiments()
const locale = useI18nLocale()
const i18n = useI18n()

const {
  public: { KILL_BUYBACK_FUNNEL, FF_ENABLE_BM_PRO_LINK_BY_COUNTRY },
} = useRuntimeConfig()
const isBuybackEnabled = computed(
  () => features.buyback?.headerButtonEnabled && !KILL_BUYBACK_FUNNEL,
)

const isBmProButtonEnabled = computed(() => {
  const { countryCode } = market

  return (
    experiments['experiment.bmProHeaderButton'] === 'withBmProHeaderButton' &&
    FF_ENABLE_BM_PRO_LINK_BY_COUNTRY.includes(countryCode)
  )
})
</script>
